const CONFIG = {
  apiUrl: window.__CONFIG__?.API_URL ?? import.meta.env.VITE_API_URL,
}

export default CONFIG
